import * as Types from '../../../../../../.cache/__types__/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActorCardsAndProfilesQueryVariables = Types.Exact<{
  timezone: Types.Scalars['String']['input'];
}>;


export type ActorCardsAndProfilesQuery = { __typename?: 'Query', actor?: { __typename?: 'Actor', cards?: { __typename?: 'CardsConnection', edges?: Array<{ __typename?: 'CardEdge', node?: { __typename?: 'Card', id: string, created_at?: any | null, properties?: { __typename?: 'CardProperties', title?: { __typename?: 'CardProperty', id: string, value?: string | null } | null } | null, profile?: { __typename?: 'Profile', role: Types.WorkspaceRole, workspace?: { __typename?: 'Workspace', type?: Types.WorkspaceType | null } | null } | null } | null }> | null } | null, profiles?: Array<{ __typename?: 'Profile', id: string, role: Types.WorkspaceRole, workspace?: { __typename?: 'Workspace', id: string, type?: Types.WorkspaceType | null } | null }> | null, workspaces?: Array<{ __typename?: 'Workspace', id: string, type?: Types.WorkspaceType | null, tags?: { __typename?: 'WorkspaceTags', disable_member_card_creation?: boolean | null } | null }> | null } | null };


export const ActorCardsAndProfilesDocument = gql`
    query ActorCardsAndProfiles($timezone: String!) {
  actor(timezone: $timezone) {
    cards {
      edges {
        node {
          id
          properties {
            title {
              id
              value
            }
          }
          created_at
          profile {
            workspace {
              type
            }
            role
          }
        }
      }
    }
    profiles {
      id
      role
      workspace {
        id
        type
      }
    }
    workspaces {
      id
      type
      tags {
        disable_member_card_creation
      }
    }
  }
}
    `;

/**
 * __useActorCardsAndProfilesQuery__
 *
 * To run a query within a React component, call `useActorCardsAndProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActorCardsAndProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActorCardsAndProfilesQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useActorCardsAndProfilesQuery(baseOptions: Apollo.QueryHookOptions<ActorCardsAndProfilesQuery, ActorCardsAndProfilesQueryVariables> & ({ variables: ActorCardsAndProfilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActorCardsAndProfilesQuery, ActorCardsAndProfilesQueryVariables>(ActorCardsAndProfilesDocument, options);
      }
export function useActorCardsAndProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActorCardsAndProfilesQuery, ActorCardsAndProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActorCardsAndProfilesQuery, ActorCardsAndProfilesQueryVariables>(ActorCardsAndProfilesDocument, options);
        }
export function useActorCardsAndProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActorCardsAndProfilesQuery, ActorCardsAndProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActorCardsAndProfilesQuery, ActorCardsAndProfilesQueryVariables>(ActorCardsAndProfilesDocument, options);
        }
export type ActorCardsAndProfilesQueryHookResult = ReturnType<typeof useActorCardsAndProfilesQuery>;
export type ActorCardsAndProfilesLazyQueryHookResult = ReturnType<typeof useActorCardsAndProfilesLazyQuery>;
export type ActorCardsAndProfilesSuspenseQueryHookResult = ReturnType<typeof useActorCardsAndProfilesSuspenseQuery>;
export type ActorCardsAndProfilesQueryResult = Apollo.QueryResult<ActorCardsAndProfilesQuery, ActorCardsAndProfilesQueryVariables>;